import { setBussy } from '../core.actions';

import store from '../../root/store';

export const setActionBussy = payload => {
  store.dispatch(setBussy(payload));
};
